import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { PopAgendamentoModel, PopModel, PopUpService } from "../pop-up.service";
import {
  AgendamentoTipoEnum,
  GlobalService,
} from "../../../servicos/global.service";
import { AutoUnsubscribe } from "../../../decorators/unsubscribe.decorator";
import { InterceptorService } from "../../../../interceptor-service";
import { Router } from "@angular/router";
import { OwsJSON } from "ows-library";
import { AgendamentoService } from "app/agendamento-vistorias/agendamento-form/agendamento.service";
import { AgendamentoMTService } from "app/agendamento-vistorias/agendamento-mt-form/agendamento-mt.service";
import { DadosPagamentoModel } from "app/agendamento-vistorias/agendamento-go-form/models/DadosPagamento.model";
import { TermosCondicoesPIComponent } from "app/compartilhado/componentes/termos-condicoes/termos-condicoes-pi/termos-condicoes-pi.component";
import { AgendamentoESService } from "app/agendamento-vistorias/agendamento-es-form/agendamento-es.service";

declare const $: any;

@Component({
  selector: "app-pop-up-alerta", // injetado no app.component
  templateUrl: "./pop-up-alerta.component.html",
  styleUrls: ["../pop-up.scss"],
})
export class PopUpAlertaComponent implements OnInit {
  @ViewChild("CheckBoxTermos") checkBoxTermos: ElementRef;

  myPopSimples = new PopModel(); // obj para preencher o pop-up simples
  myPopPergunta = new PopModel(); // obj para preencher o pop-up pergunta
  myPopAgendamento = new PopAgendamentoModel();
  agendamentoMTService: AgendamentoMTService;
  agendamentoESService: AgendamentoESService;
  temaDark = this.globalService.tema;
  temaLight = !this.temaDark;
  confirmarDisabled = true;
  realizaPagamento = false;
  modoImpressao = false;
  exibeVeiculoPorte = true;
  exibeDataMarcada = true;
  exibeLocalVistoria = true;
  myPopTitulo = "Confimação de agendamento";
  comprovanteTitulo = "Comprovante de agendamento";
  tituloConfirmacao = "Agendamento de vistoria confirmado com sucesso!";
  empresaUF = "PI";
  /*  Constrói o PopUp, instaciando todos os serviços a serem utilizados pela mesma
 Se necessário, checa as permissoes de usuário para permitir quais operações de Crud poderão ser executadas */
  constructor(
    private router: Router,
    public agendamentoService: AgendamentoService,
    public popUpService: PopUpService,
    public globalService: GlobalService,
    private interceptorService: InterceptorService
  ) {}

  retornoPadrao() {
    // retorno do popup simples
    this.popUpService.respostaSubOk.next(true); // envia a resposta [ok] (só ouça se quiser realizar algo após o clique no botão[ok] )
  }

  confirmaAgendamento() {
    this.popUpService.agendamentoRespostaSub.next(true); // envia a resposta [sim]
  }

  confirmaSair() {
    this.popUpService.sairRespostaSub.next(true);
  }

  confirmaAcao() {
    // retorno positivo [sim] do popup de ação
    this.popUpService.respostaSub.next(true); // envia a resposta [sim]
  }

  negaAcao() {
    // retorno negativo [não] do popup de ação
    this.popUpService.respostaSub.next(false); // envia a resposta [não]
  }

  ngOnInit() {
    this.globalService.temaSub.subscribe((tema) => {
      if (tema) {
        this.temaDark = true;
        this.temaLight = false;
      } else {
        this.temaDark = false;
        this.temaLight = true;
      }

      $("#agendamentoModal").modal("show");
      $("#agendamentoModal").on("shown.bs.modal", () => {
        $("#btnOkay").focus();
      });
      if (this.popUpService.templateIsShowing) {
        $("#myModalTemplate").modal("hide");
        this.popUpService.templateHasToComeBack = true; // indica que o template deve aparecer novamente, pois foi escondido para exibir o alerta
      }
    });

    this.popUpService.agendadoSub.subscribe((modoImpressao) => {
      this.modoImpressao = modoImpressao;
      $("#agendadoModal").modal("show");
      $("#agendadoModal").on("shown.bs.modal", () => {
        $("#btnOkay").focus();
      });
      if (this.popUpService.templateIsShowing) {
        $("#myModalTemplate").modal("hide");
        this.popUpService.templateHasToComeBack = true; // indica que o template deve aparecer novamente, pois foi escondido para exibir o alerta
      }
    });

    this.popUpService.atualizarDadosSub.subscribe((dados) => {
      this.myPopAgendamento.CpfCnpj = dados.CpfCnpj;
    });

    this.popUpService.agendadoMTSub.subscribe((modalAgendamento) => {
      this.modoImpressao = modalAgendamento.modoImpressao;
      this.agendamentoMTService = modalAgendamento.agendamentoMTService;
      this.realizaPagamento = this.agendamentoMTService.realizaPagamento;
      $("#agendadoModal").modal("show");
      $("#agendadoModal").on("shown.bs.modal", () => {
        $("#btnOkay").focus();
      });
      if (this.popUpService.templateIsShowing) {
        $("#myModalTemplate").modal("hide");
        this.popUpService.templateHasToComeBack = true; // indica que o template deve aparecer novamente, pois foi escondido para exibir o alerta
      }
    });

    this.popUpService.agendadoESSub.subscribe((modalAgendamento) => {
      this.modoImpressao = modalAgendamento.modoImpressao;
      this.agendamentoESService = modalAgendamento.agendamentoESService;
      this.realizaPagamento = this.agendamentoESService.realizaPagamento;
      $("#agendadoModal").modal("show");
      $("#agendadoModal").on("shown.bs.modal", () => {
        $("#btnOkay").focus();
      });
      if (this.popUpService.templateIsShowing) {
        $("#myModalTemplate").modal("hide");
        this.popUpService.templateHasToComeBack = true; // indica que o template deve aparecer novamente, pois foi escondido para exibir o alerta
      }
    });

    this.popUpService.informacoesSub.subscribe((dados) => {
      $("#informacoesModal").modal("show");
      $("#informacoesModal").on("shown.bs.modal", () => {
        $("#btnOkay").focus();
      });
      if (this.popUpService.templateIsShowing) {
        $("#informacoesModal").modal("hide");
        this.popUpService.templateHasToComeBack = true; // indica que o template deve aparecer novamente, pois foi escondido para exibir o alerta
      }
    });

    this.popUpService.agendamentoSub.subscribe((dados) => {
      if (
        this.popUpService.agendamentoTipo == AgendamentoTipoEnum.MT ||
        this.popUpService.agendamentoTipo == AgendamentoTipoEnum.ES
      ) {
        this.exibeVeiculoPorte = !(
          dados.VeiculoPorte == "" || dados.VeiculoPorte == null
        );
        this.exibeDataMarcada = false;
        this.myPopTitulo = "Confirmação de solicitação";
        this.comprovanteTitulo = "Comprovante de solicitação";
        this.tituloConfirmacao =
          "Solicitação de vistoria confirmada com sucesso!";
        this.empresaUF = dados.Uf;
        this.checkBoxTermos.nativeElement.checked = false;
        this.confirmarDisabled = true;
        this.myPopAgendamento = OwsJSON.clone(dados);
        if (dados.LocalVistoria == null || dados.LocalVistoria == "")
          this.exibeLocalVistoria = false;
        else {
          this.exibeLocalVistoria = true;
          this.myPopAgendamento.LocalVistoria = dados.LocalVistoriaString;
        }

        this.myPopAgendamento.VeiculoPorte = dados.VeiculoPorteString;
        this.myPopAgendamento.CpfCnpj = dados.CpfCnpj;
        this.myPopAgendamento.Telefone = this.formatarTelefone(dados.Telefone);
      } else {
        if (this.agendamentoService.consultaPorCnpj) {
          dados.Municipio = "";
          dados.TipoVistoria = "";
          dados.Uf = "";
        }

        this.checkBoxTermos.nativeElement.checked = false;
        this.confirmarDisabled = true;

        this.myPopAgendamento = OwsJSON.clone(dados);
        this.myPopAgendamento.CpfCnpj = dados.CpfCnpj;
        this.myPopAgendamento.Telefone = this.formatarTelefone(dados.Telefone);
        this.myPopAgendamento.DataInicio =
          dados.DataInicio?.toLocaleDateString("pt-BR");

        this.myPopAgendamento.LocalVistoria =
          this.agendamentoService.listaLocaisVistoria.find(
            (x) => x.Key === dados.LocalVistoria
          ).Value;
        this.myPopAgendamento.VeiculoPorte =
          this.agendamentoService.listaTiposVeiculos.find(
            (x) => x.Key === dados.VeiculoPorte
          ).Value;
      }

      $("#agendamentoModal").modal("show");
      $("#agendamentoModal").on("shown.bs.modal", () => {
        $("#btnOkay").focus();
      });
      if (this.popUpService.templateIsShowing) {
        $("#myModalTemplate").modal("hide");
        this.popUpService.templateHasToComeBack = true; // indica que o template deve aparecer novamente, pois foi escondido para exibir o alerta
      }
    });

    this.popUpService.notificaSub.subscribe((dados) => {
      // escuta o subject notificaSub
      this.myPopSimples = dados;
      $("#myModal").modal("show");
      $("#myModal").on("shown.bs.modal", () => {
        $("#btnOkay").focus();
      });
      // this.btnOkSimples.nativeElement.focus();
      if (this.popUpService.templateIsShowing) {
        $("#myModalTemplate").modal("hide");
        this.popUpService.templateHasToComeBack = true; // indica que o template deve aparecer novamente, pois foi escondido para exibir o alerta
      }
    });

    this.popUpService.perguntaSub.subscribe((dados) => {
      // escuta o subject perguntaSub
      this.myPopPergunta = dados;
      $("#myModalQuestion").modal("show");
      $("#myModalQuestion").on("shown.bs.modal", () => {
        $("#btnNao").focus();
      });
      if (this.popUpService.templateIsShowing) {
        // caso o pop-up template esteja sendo exibido
        $("#myModalTemplate").modal("hide");
        this.popUpService.templateHasToComeBack = true; // indica que o template deve aparecer novamente, pois foi escondido para exibir o alerta
      }
    });

    this.popUpService.perguntaSub2.subscribe((dados) => {
      // escuta o subject perguntaSub
      this.myPopPergunta = dados;
      $("#myModalQuestion2").modal("show");
      $("#myModalQuestion2").on("shown.bs.modal", () => {
        $("#btnNao").focus();
      });
      if (this.popUpService.templateIsShowing) {
        // caso o pop-up template esteja sendo exibido
        $("#myModalTemplate").modal("hide");
        this.popUpService.templateHasToComeBack = true; // indica que o template deve aparecer novamente, pois foi escondido para exibir o alerta
      }
    });

    $("#informacoesModal").on("hidden.bs.modal", () => {
      this.confirmaInformacao();
    });

    if (this.popUpService.agendamentoTipo === AgendamentoTipoEnum.PI) {
      $("#termosModal").on("hidden.bs.modal", () => {
        $("#agendamentoModal").modal("show");
        $("#agendamentoModal").on("shown.bs.modal", () => {
          $("#btnOkay").focus();
        });
        if (this.popUpService.templateIsShowing) {
          $("#myModalTemplate").modal("hide");
          this.popUpService.templateHasToComeBack = true; // indica que o template deve aparecer novamente, pois foi escondido para exibir o alerta
        }
      });
    }

    $("#agendamentoModal").on("hidden.bs.modal", () => {
      if (this.popUpService.templateHasToComeBack) {
        this.popUpService.showPopTemplate();
        this.popUpService.templateIsShowing = true;
        this.popUpService.templateHasToComeBack = false;
        // Informa aos listeners que o pop-up fechou, permitindo a execução de funções que dependem desse evento.
        this.popUpService.popFechouSub.next(true);
      }
    });

    $("#agendadoModal").on("hidden.bs.modal", () => {
      this.popUpService.showBotaoComprovante();
      if (this.popUpService.templateHasToComeBack) {
        this.popUpService.showPopTemplate();
        this.popUpService.templateIsShowing = true;
        this.popUpService.templateHasToComeBack = false;
        // Informa aos listeners que o pop-up fechou, permitindo a execução de funções que dependem desse evento.
        this.popUpService.popFechouSub.next(true);
      }
    });

    $("#myModal").on("hidden.bs.modal", () => {
      // evento disparado ao fechar / esconder o modal simples
      if (this.popUpService.templateHasToComeBack) {
        this.popUpService.showPopTemplate();
        this.popUpService.templateIsShowing = true;
        this.popUpService.templateHasToComeBack = false;
        // Informa aos listeners que o pop-up fechou, permitindo a execução de funções que dependem desse evento.
        this.popUpService.popFechouSub.next(true);
      }
    });

    $("#myModalQuestion").on("hidden.bs.modal", () => {
      // evento disparado ao fechar / esconder o modal de pergunta
      if (this.popUpService.templateHasToComeBack) {
        this.popUpService.showPopTemplate();
        this.popUpService.templateIsShowing = true;
        this.popUpService.templateHasToComeBack = false;
        // Informa aos listeners que o pop-up fechou, permitindo a execução de funções que dependem desse evento.
        this.popUpService.popFechouSub.next();
      }
    });

    $("#myModalQuestion2").on("hidden.bs.modal", () => {
      // evento disparado ao fechar / esconder o modal de pergunta
      if (this.popUpService.templateHasToComeBack) {
        this.popUpService.showPopTemplate();
        this.popUpService.templateIsShowing = true;
        this.popUpService.templateHasToComeBack = false;
        // Informa aos listeners que o pop-up fechou, permitindo a execução de funções que dependem desse evento.
        this.popUpService.popFechouSub.next();
      }
    });
  }

  formatarCpf(cpf) {
    //retira os caracteres indesejados...
    cpf = cpf.replace(/[^\d]/g, "");
    //realizar a formatação...
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  }

  formatarTelefone(telefone) {
    const telefoneAjustado = telefone.replace(
      /(\d{2})(\d{5})(\d{4})/,
      function (regex, arg1, arg2, arg3) {
        return "(" + arg1 + ") " + arg2 + "-" + arg3;
      }
    );
    return telefoneAjustado;
  }

  modalClick() {
    $("#termosModal").modal("show");
    $("#termosModal").on("shown.bs.modal", () => {
      $("#btnNao").focus();
    });
    $("#agendamentoModal").modal("hide");
    if (this.popUpService.templateIsShowing) {
      // caso o pop-up template esteja sendo exibido
      $("#agendamentoModal").modal("hide");
      this.popUpService.templateHasToComeBack = true; // indica que o template deve aparecer novamente, pois foi escondido para exibir o alerta
    }
  }

  checkTermosChanged(e) {
    this.confirmarDisabled = !this.checkBoxTermos.nativeElement.checked;
  }

  confirmaInformacao() {
    if (this.popUpService.agendamentoTipo === AgendamentoTipoEnum.PI) {
      this.popUpService.confirmaInformacaoPIChanged.next();
    } else if (this.popUpService.agendamentoTipo === AgendamentoTipoEnum.GO) {
      this.popUpService.confirmaInformacaoGOChanged.next();
    } else if (this.popUpService.agendamentoTipo === AgendamentoTipoEnum.MT) {
      this.popUpService.confirmaInformacaoMTChanged.next();
    } else if (this.popUpService.agendamentoTipo === AgendamentoTipoEnum.ES) {
      this.popUpService.confirmaInformacaoESChanged.next();
    }
  }

  onSair() {
    this.agendamentoService.localVistoriaAgendamento = "";
    this.agendamentoService.municipioAgendamento = "";
    this.agendamentoService.tipoVistoriaAgendamento = "";
    document.location.href =
      "http://www.detran.pi.gov.br/parceiros/empresas-de-vistoria/";
  }

  onEfetuarPagamento() {
    if (this.popUpService.agendamentoTipo == AgendamentoTipoEnum.ES)
      this.agendamentoESService.exibirBotoesPagamento();
    else if (this.popUpService.agendamentoTipo == AgendamentoTipoEnum.MT)
      this.agendamentoMTService.exibirBotoesPagamento();
    else {
      this.agendamentoService.dadosPagamento = new DadosPagamentoModel();
      this.agendamentoService.dadosPagamento.CpfCnpj =
        this.myPopAgendamento.CpfCnpj;
      this.agendamentoService.dadosPagamento.Email =
        this.myPopAgendamento.Email;
      this.agendamentoService.dadosPagamento.EmpresaId =
        this.agendamentoService.listaLocaisVistoria.find(
          (x) => x.Value === this.myPopAgendamento.LocalVistoria
        ).Key;
      this.agendamentoService.dadosPagamento.Nome = this.myPopAgendamento.Nome;
      this.agendamentoService.dadosPagamento.Placa =
        this.myPopAgendamento.Placa.toUpperCase();
      const splitTelefone = this.myPopAgendamento.Telefone.split(" ");
      this.agendamentoService.dadosPagamento.Telefone = splitTelefone[1];
      this.agendamentoService.dadosPagamento.TelefoneDDD =
        splitTelefone[0].replace("[()]", "");
      this.agendamentoService.exibirBotoesPagamento();
    }
  }

  imprimirComprovante() {
    let popupWin;
    let comprovanteBoleto = "";

    popupWin = window.open("", "_blank");
    popupWin.document.open();

    if (this.popUpService.agendamentoTipo == AgendamentoTipoEnum.MT) {
      comprovanteBoleto =
        '<html><head><title>Comprovante de solicitação de vistoria</title><style> </style></head><body onload="window.print();window.close()"><div>';

      if (this.exibeLocalVistoria)
        comprovanteBoleto +=
          "<p><strong>Local:</strong><p>" +
          "<p>" +
          this.myPopAgendamento.LocalVistoria +
          "<br></p>";

      comprovanteBoleto +=
        "<hr><p><strong>Dados do veículo:</strong></p>" +
        "<p><strong>Placa: </strong>" +
        this.myPopAgendamento.Placa.toUpperCase() +
        "<br>" +
        "<strong>Renavam: </strong>" +
        this.myPopAgendamento.Renavam +
        "<br>";

      if (
        this.myPopAgendamento.VeiculoPorte != "" &&
        this.myPopAgendamento.VeiculoPorte != null
      )
        comprovanteBoleto +=
          "<strong>Porte do Veículo: </strong>" +
          this.myPopAgendamento.VeiculoPorte +
          "</p>";

      comprovanteBoleto +=
        "<hr><p><strong>Dados do solicitante:</strong></p>" +
        "<p><strong>Nome Completo: </strong>" +
        this.myPopAgendamento.Nome +
        "<br>" +
        "<strong>CPF/CNPJ: </strong>" +
        this.myPopAgendamento.CpfCnpj +
        "<br>" +
        "<strong>Email: </strong>" +
        this.myPopAgendamento.Email +
        "<br>" +
        "<strong>Telefone celular: </strong>" +
        this.myPopAgendamento.Telefone +
        "</p></br></div></body></html>";
    } else {
      comprovanteBoleto =
        '<html><head><title>Comprovante de agendamento</title><style> </style></head><body onload="window.print();window.close()"><div>' +
        "<p><strong>Local:</strong><p>" +
        "<p>" +
        this.myPopAgendamento.LocalVistoria +
        "<br>" +
        this.myPopAgendamento.Municipio +
        "</p>" +
        "<hr>" +
        "<p><strong>Horário:</strong><p>" +
        "<p>" +
        this.myPopAgendamento.DataInicio +
        ", às " +
        this.myPopAgendamento.HorarioInicio +
        "</p>" +
        "<hr><p><strong>Dados do veículo:</strong></p>" +
        "<p><strong>Placa: </strong>" +
        this.myPopAgendamento.Placa.toUpperCase() +
        "<br>" +
        "<strong>Renavam: </strong>" +
        this.myPopAgendamento.Renavam +
        "<br>" +
        "<strong>Porte do Veículo: </strong>" +
        this.myPopAgendamento.VeiculoPorte +
        "</p>" +
        "<hr><p><strong>Dados do solicitante:</strong></p>" +
        "<p><strong>Nome Completo: </strong>" +
        this.myPopAgendamento.Nome +
        "<br>" +
        "<strong>CPF/CNPJ: </strong>" +
        this.myPopAgendamento.CpfCnpj +
        "<br>" +
        "<strong>Email: </strong>" +
        this.myPopAgendamento.Email +
        "<br>" +
        "<strong>Telefone celular: </strong>" +
        this.myPopAgendamento.Telefone +
        "</p></br></div></body></html>";
    }

    popupWin.document.write(comprovanteBoleto);

    // Abre diretamente a página de impressão apenas se não estiver no modo Mobile
    if (!this.globalService.isMobileExtra()) {
      popupWin.document.close();
    }
  }

  imprimir() {
    let printContents, popupWin;
    popupWin = window.open("", "_blank");
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Termos de Ciência sobre os Serviços de Vistoria Veicular</title>
        </head>
        <body onload="window.print();window.close()">
          <div>
            <h2>Termo de Ci&ecirc;ncia sobre os Servi&ccedil;os de Vistoria Veicular</h2>
            <p>&nbsp;</p>
            <p>O presente termo aplica-se aos servi&ccedil;os de vistoria veicular realizados pela empresa selecionada, doravante identificada como Credenciada.</p>
            <ol>
              <li><strong> Natureza dos servi&ccedil;os prestados</strong></li>
            </ol>
            <p>1.1 O servi&ccedil;o de vistoria veicular &eacute; disciplinado pelo C&oacute;digo de Tr&acirc;nsito Brasileiro, Resolu&ccedil;&otilde;es do CONTRAN e Portarias do DENATRAN e do DETRAN/PI, possuindo car&aacute;ter obrigat&oacute;rio, tendo como objetivo a verifica&ccedil;&atilde;o da autenticidade da identifica&ccedil;&atilde;o do ve&iacute;culo e da sua documenta&ccedil;&atilde;o; a legitimidade da propriedade; se os ve&iacute;culos disp&otilde;em dos equipamentos obrigat&oacute;rios, e se estes est&atilde;o funcionais e por fim se as caracter&iacute;sticas originais dos ve&iacute;culos e seus agregados foram modificados e, caso constatada alguma altera&ccedil;&atilde;o, se esta foi autorizada, regularizada e se consta no prontu&aacute;rio do ve&iacute;culo na reparti&ccedil;&atilde;o de tr&acirc;nsito.</p>
            <p>1.2 Requisitos e itens b&aacute;sicos de seguran&ccedil;a tamb&eacute;m fazem parte do escopo da vistoria, conforme legisla&ccedil;&atilde;o vigente.</p>
            <p>1.3 &Eacute; de exclusiva responsabilidade do Usu&aacute;rio identificar se os servi&ccedil;os dos quais necessita enquadram-se nos escopos de vistorias atendidos pela Credenciada.</p>
            <ol start="2">
              <li><strong> Aceita&ccedil;&atilde;o dos Termos</strong></li>
            </ol>
            <p>2.1 Para usar os Servi&ccedil;os, o usu&aacute;rio dever&aacute; primeiro concordar com os Termos. N&atilde;o &eacute; permitido o uso dos Servi&ccedil;os por parte do usu&aacute;rio sem que haja concord&acirc;ncia irrestrita e integral dos Termos.</p>
            <p>2.2 O usu&aacute;rio pode aceitar os Termos:</p>
            <p>2.2.1 clicando para aceitar ou concordar, no caso de essa op&ccedil;&atilde;o ser disponibilizada pelo Site de Agendamento na interface do usu&aacute;rio do Servi&ccedil;o;</p>
            <p>2.2.2 realizando o pagamento; ou,</p>
            <p>2.2.3 usando efetivamente os Servi&ccedil;os. Nesse caso, o usu&aacute;rio compreende e aceita que a Credenciada considerar&aacute; seu uso dos Servi&ccedil;os uma aceita&ccedil;&atilde;o dos Termos a partir desse momento.</p>
            <ol start="3">
              <li><strong> Pagamento e Reembolso</strong></li>
            </ol>
            <p>3.1 Em caso de desist&ecirc;ncia de realiza&ccedil;&atilde;o do servi&ccedil;o, o usu&aacute;rio apenas ter&aacute; direito ao reembolso, caso o cancelamento da vistoria e a solicita&ccedil;&atilde;o de estorno se d&ecirc; em prazo superior a 24 horas de anteced&ecirc;ncia do hor&aacute;rio agendado para a vistoria;</p>
            <p>3.2 N&atilde;o haver&aacute; reembolso, em hip&oacute;tese alguma, para ve&iacute;culos cujos servi&ccedil;os de vistoria j&aacute; tenham sido parciais ou totalmente realizados;</p>
            <ol start="4">
              <li><strong> Agendamento dos Servi&ccedil;os</strong></li>
            </ol>
            <p>4.1 Os servi&ccedil;os tratados neste Termo ser&atilde;o executados mediante agendamento pr&eacute;vio, em local, data e hor&aacute;rio de livre escolha do usu&aacute;rio, desde que respeitando a disponibilidade de vagas;</p>
            <p>4.2 O agendamento dever&aacute; ser precedido da confirma&ccedil;&atilde;o de pagamento;</p>
            <p>4.3 Uma vez realizado o pagamento, o usu&aacute;rio estar&aacute; impedido de alterar o local de vistoria;</p>
            <p>4.4 O usu&aacute;rio dever&aacute; comparecer ao local de agendamento na data e hor&aacute;rio previamente agendado, com toler&acirc;ncia m&aacute;xima de 15 (quinze) minutos de atraso. Excedendo-se esse limite, caracteriza-se o n&atilde;o comparecimento &agrave; vistoria, conforme prev&ecirc; o item 4.5;</p>
            <p>4.5 O n&atilde;o comparecimento ao local de vistoria em data e hora previamente agendados implicar&aacute; no cancelamento autom&aacute;tico do agendamento.</p>
            <ol start="5">
              <li><strong> Realiza&ccedil;&atilde;o da Vistoria</strong></li>
            </ol>
            <p>5.1 O tempo m&eacute;dio de espera para a completa realiza&ccedil;&atilde;o da vistoria &eacute; de 45 minutos, podendo variar para mais ou para menos, de acordo com o tipo e as condi&ccedil;&otilde;es do ve&iacute;culo vistoriado.</p>
            <ol start="6">
              <li><strong> Da validade do laudo de vistoria</strong></li>
            </ol>
            <p>6.1 O Laudo de Vistorias ter&aacute; validade de 30 (trinta) dias, contados a partir da data de sua aprova&ccedil;&atilde;o.</p>
            <ol start="7">
              <li><strong> Dos casos de n&atilde;o conformidade</strong></li>
            </ol>
            <p>7.1 O propriet&aacute;rio de ve&iacute;culo que teve sua vistoria reprovada ter&aacute; por uma &uacute;nica vez, no prazo m&aacute;ximo de trinta 30 (trinta) dias corridos, incluindo finais de semanas e feriados, contados da data da vistoria, para comparecer na Credenciada, ap&oacute;s o saneamento da(s) irregularidade(s) detectada(s) no ve&iacute;culo, para realiza&ccedil;&atilde;o de nova vistoria, sem &ocirc;nus.</p>
            <p>7.2 Caso o motivo da reprova necessite de procedimentos adicionais junto ao Departamento Estadual de Tr&acirc;nsito - DETRAN ser&aacute; deduzido o per&iacute;odo em que o processo esteve em tramita&ccedil;&atilde;o aguardando provid&ecirc;ncias da Entidade Executiva de Tr&acirc;nsito do Estado, devidamente comprovado.</p>
            <p>7.3 Expirado o prazo de 30 (trinta) dias de que trata o item 7.1 o Usu&aacute;rio dever&aacute; pagar nova taxa de vistoria, bem como realizar novo agendamento.</p>
            <p>7.4 Caso n&atilde;o regularize o motivo da reprova e retorne, o ve&iacute;culo ficar&aacute; por 180 dias vinculado &agrave; unidade que realizou a vistoria ou at&eacute; que tenha um laudo aprovado na mesma.</p>
            <ol start="8">
              <li><strong> San&ccedil;&otilde;es e Procedimentos Aplic&aacute;veis</strong></li>
            </ol>
            <p>8.1 &Eacute; dever da Credenciada realizar servi&ccedil;o ison&ocirc;mico e imparcial para todos os usu&aacute;rios, identificando pontos pass&iacute;veis de reprova dos ve&iacute;culos vistoriados, quando aplic&aacute;vel.</p>
            <p>8.2 Constatada a diverg&ecirc;ncia de informa&ccedil;&otilde;es em qualquer das bases, seja ela Estadual ou Federal, ainda que a proced&ecirc;ncia e autenticidade da identifica&ccedil;&atilde;o do ve&iacute;culo tenham sido comprovadas pela vistoria, implicar&aacute; no bloqueio autom&aacute;tico do ve&iacute;culo at&eacute; regulariza&ccedil;&atilde;o cadastral junto ao Detran.</p>
            <p>8.3 Uma vez regularizada a informa&ccedil;&atilde;o cadastral do ve&iacute;culo junto ao Detran, o Usu&aacute;rio dever&aacute; reagendar nova vistoria no prazo estipulado no item 7.1, para a confirma&ccedil;&atilde;o da regulariza&ccedil;&atilde;o do cadastro e desbloqueio do ve&iacute;culo, deduzido o per&iacute;odo em que o processo esteve em tramita&ccedil;&atilde;o aguardando provid&ecirc;ncias da Entidade Executiva de Tr&acirc;nsito do Estado, devidamente comprovado.</p>
            <p>8.4 Quando da realiza&ccedil;&atilde;o das vistorias, a Credenciada detectar ind&iacute;cios de adultera&ccedil;&atilde;o dos agregados do ve&iacute;culo, de acordo com as codifica&ccedil;&otilde;es fornecidas pelo fabricante, especificamente nas numera&ccedil;&otilde;es do chassi e do motor, bem como no(s) caracter(es) da(s) placa(s) de identifica&ccedil;&atilde;o, e ainda, no caso de ve&iacute;culo que consta prenotada em seu cadastro, a restri&ccedil;&atilde;o de ocorr&ecirc;ncia de furto/roubo, dever&aacute; reprovar as Vistorias e anotar no respectivo Laudo, informa&ccedil;&otilde;es de identifica&ccedil;&atilde;o da pessoa que apresentou o ve&iacute;culo para ser vistoriado, encaminhando, de imediato, todos esses dados ao DETRAN, para a ado&ccedil;&atilde;o de provid&ecirc;ncias.</p>
            <p>8.5 A vistoria veicular &eacute; um servi&ccedil;o de concess&atilde;o p&uacute;blica, como tal, qualquer tentativa de influ&ecirc;ncia por parte do Usu&aacute;rio, e oferecimento de vantagem il&iacute;cita ao profissional &agrave; servi&ccedil;o da Credenciada, no sentido de alterar os resultados normais da vistoria, poder&aacute; ser caracterizada como corrup&ccedil;&atilde;o ativa, e estar&aacute; sujeita &agrave;s penalidades previstas na lei.</p>
            <p>Ao prosseguir com a execu&ccedil;&atilde;o dos servi&ccedil;os, declaro estar ciente dos termos acima listados.</p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
          </div>
        </body>
      </html>`);

    // Abre diretamente a página de impressão apenas se não estiver no modo Mobile
    if (!this.globalService.isMobileExtra()) {
      popupWin.document.close();
    }
  }

  imprimirTermoMG() {
    const impressaoHTML = `
      <html>
        <head>
          <title>Termos de Ciência sobre os Serviços de Vistoria Veicular</title>
        </head>
        <body 
        onload="openAndPrint()">
          <div>
            <p>O presente termo aplica-se aos serviços de vistoria veicular realizados pela empresa selecionada, doravante identificada como Credenciada.<p>
            <p><b>1.	Natureza dos serviços prestados</b></p>
            <p>
              1.1 O serviço de vistoria veicular é disciplinado pelo Código de Trânsito Brasileiro, Resoluções do CONTRAN e Portarias do DENATRAN e do
              DETRAN-MG, possuindo caráter obrigatório, tendo como objetivo a verificação da autenticidade da identificação do veículo e da sua documentação;
              a legitimidade da propriedade; se os veículos dispõem dos equipamentos obrigatórios, e se estes estão funcionais e por fim se as características
              originais dos veículos e seus agregados foram modificados e, caso constatada alguma alteração, se esta foi autorizada, regularizada e se consta no
              prontuário do veículo na repartição de trânsito.
            </p>
            <p>1.2 Requisitos e itens básicos de segurança também fazem parte do escopo da vistoria, conforme legislação vigente.</p>
            <p>1.3 É de exclusiva responsabilidade do Usuário identificar se os serviços dos quais necessita enquadram-se nos escopos de vistorias atendidos pela Credenciada.</p>
            <p><b>
              2.	Aceitação dos Termos
            </b></p>
            <p>2.1 Para usar os Serviços, o usuário deverá primeiro concordar com os Termos. Não é permitido o uso dos Serviços por parte do usuário sem que haja concordância irrestrita e integral dos Termos.</p>
            <p>2.2 O usuário pode aceitar os Termos:</p>
            <p>2.2.1 clicando para aceitar ou concordar, no caso de essa opção ser disponibilizada pelo Site de Agendamento na interface do usuário do Serviço; ou,</p>
            <p>2.2.2 usando efetivamente os Serviços. Nesse caso, o usuário compreende e aceita que a Credenciada considerará seu uso dos Serviços uma aceitação dos Termos a partir desse momento.</p>
            <p><b>3.	Agendamento dos Serviços</b></p>
            <p>3.1 Os serviços tratados neste Termo serão executados mediante agendamento prévio, em data e horário de livre escolha do usuário, desde que respeitando a disponibilidade de vagas;</p>
            <p>
              3.2 O usuário deverá comparecer ao local de agendamento na data e horário previamente agendado, com tolerância máxima de 15 (quinze) minutos de atraso. Excedendo-se esse limite,
              caracteriza-se o não comparecimento à vistoria, conforme prevê o item 3.3;
            </p>
            <p>3.3 O não comparecimento ao local de vistoria em data e hora previamente agendados implicará no cancelamento automático do agendamento.</p>
            <p><b>4.	Realização da Vistoria</b></p>
            <p>4.1 O tempo médio de espera para a completa realização da vistoria é de 45 minutos, podendo variar para mais ou para menos, de acordo com o tipo e as condições do veículo vistoriado.</p>
            <p><b>5.	Da validade do laudo de vistoria</b></p>
            <p>5.1 O Laudo de Vistorias terá validade de 30 (trinta) dias, contados a partir da data de sua aprovação.</p>
            <p><b>6.	Dos casos de não conformidade</b></p>
            <p>
              6.1 O proprietário de veículo que teve sua vistoria reprovada terá por uma única vez, no prazo máximo de trinta 30 (trinta) dias corridos, incluindo finais de semanas e feriados,
              contados da data da vistoria, para comparecer na Credenciada, após o saneamento da(s) irregularidade(s) detectada(s) no veículo, para realização de nova vistoria, sem ônus.
            </p>
            <p>
              6.2 Caso o motivo da reprova necessite de procedimentos adicionais junto ao Departamento Estadual de Trânsito de Minas Gerias - DETRAN-MG será deduzido o período em que o processo
              esteve em tramitação aguardando providências da Entidade Executiva de Trânsito do Estado de Minas Gerias, devidamente comprovado.
            </p>
            <p>6.3 Expirado o prazo de 30 (trinta) dias de que trata o item 6.1 o Usuário deverá pagar nova taxa de vistoria junto ao DETRAN-MG, bem como realizar novo agendamento.</p>
            <p><b>7.	Sanções e Procedimentos Aplicáveis</b></p>
            <p>7.1 É dever da Credenciada realizar serviço isonômico e imparcial para todos os usuários, identificando pontos passíveis de reprova dos veículos vistoriados, quando aplicável.</p>
            <p>
              7.2 Constatada a divergência de informações em qualquer das bases, seja ela Estadual ou Federal, ainda que a procedência e autenticidade da identificação do veículo tenham sido
              comprovadas pela vistoria, implicará no bloqueio automático do veículo até regularização cadastral junto ao DETRAN-MG.
            </p>
            <p>
              7.3 Uma vez regularizada a informação cadastral do veículo junto ao DETRAN-MG, o Usuário deverá reagendar nova vistoria no prazo estipulado no item 6.1, para a confirmação da
              regularização do cadastro e desbloqueio do veículo, deduzido o período em que o processo esteve em tramitação aguardando providências da Entidade Executiva de Trânsito do Estado de Minas Gerias, devidamente comprovado.
            </p>
            <p>
              7.4 Quando da realização das vistorias, a Credenciada detectar indícios de adulteração dos agregados do veículo, de acordo com as codificações fornecidas pelo fabricante,
              especificamente nas numerações do chassi e do motor, bem como no(s) caracter(es) da(s) placa(s) de identificação, e ainda, no caso de veículo que consta prenotada em seu cadastro,
              a restrição de ocorrência de furto/roubo, deverá reprovar as Vistorias e anotar no respectivo Laudo, informações de identificação da pessoa que apresentou o veículo para ser vistoriado,
              encaminhando, de imediato, todos esses dados ao DETRAN-MG, para a adoção de providências.
            </p>
            <p>
              7.5 A vistoria veicular é um serviço de concessão pública, como tal, qualquer tentativa de influência por parte do Usuário, e oferecimento de vantagem ilícita ao profissional à serviço da Credenciada,
              no sentido de alterar os resultados normais da vistoria, poderá ser caracterizada como corrupção ativa, e estará sujeita às penalidades previstas na lei.
            </p>
            <p>Ao prosseguir com a execução dos serviços, declaro estar ciente dos termos acima listados.</p>
          </div>
        </body>
      </html>`;

    let termoServicoWindow = window.open("termo-servico", "_blank");
    termoServicoWindow.document.write(impressaoHTML);
    termoServicoWindow.print();
    termoServicoWindow.close();
  }
}

// export function openAndPrint() {
//   var is_chrome = function () {
//     return Boolean(navigator.userAgent.toLowerCase().indexOf("chrome") > -1);
//   };
//   window.onload = function () {
//     if (is_chrome) {
//       /*
//        * These 2 lines are here because as usual, for other browsers,
//        * the window is a tiny 100x100 box that the user will barely see.
//        * On Chrome, it needs to be big enough for the dialogue to be read
//        * (NB, it also includes a page preview).
//        */
//       window.moveTo(0, 0);
//       window.resizeTo(640, 480);

//       // This line causes the print dialogue to appear, as usual:
//       window.print();

//       /*
//        * This setTimeout isn't fired until after .print() has finished
//        * or the dialogue is closed/cancelled.
//        * It doesn't need to be a big pause, 500ms seems OK.
//        */
//       setTimeout(function () {
//         window.close();
//       }, 500);
//     } else {
//       // For other browsers we can do things more briefly:
//       window.print();
//       window.close();
//     }
//   };
// }
